module.exports = __webpack_public_path__ + "img/top.ad304a42.png";